export default "__VITE_ASSET__hEDtnw4e__"